import React from "react";

import PageComponent from "components/Page";

import Button from "components/Button";
import Search from "components/Search";
import ButtonIconSelect from "components/ButtonIconSelect";
import ButtonIcon from "components/ButtonIcon";
import ControlData from "components/ControlData";

import Calendar from "pages/schedule/components/Calendar";
import Doctors from "pages/schedule/components/Doctors";
import ControlDate from "pages/schedule/components/ControlDate";
import WorkHoursDialog from "pages/schedule/components/WorkHoursDialog";
import ShiftsDelDialog from "pages/schedule/components/ShiftsDelDialog";
import CabinetDialog from "pages/schedule/components/CabinetDialog";
import ScheduleView from "pages/schedule/components/ScheduleView/MainView";
import ShiftPopup from "pages/schedule/components/ShiftPopup";
//import ScheduleView from "pages/schedule/components/ScheduleView2";

import { ReactComponent as PlusIcon } from 'icons/buttons/plus.svg';

import './index.less';
import './themes/default.less';

export default class Schedule extends PageComponent {
    constructor(props) {
        super(props);

        this.shiftsDefault = {
            0: [],
            1: [],
            2: [],
            3: [],
            4: [],
            5: [],
            6: [],
        };

        this.sheet = {
            start: "08:00",
            end: "21:00"
        };

        const currentTime = 120;

        this.state = {
            ...this.state,
            isSchedule: true,
            currentDoctor: null,
            search: "",
            isEdit: false,
            isEditCabinet: false,
            schedules: [],
            dateMode: "week",
            date: new Date(),
            selectedCabinets: [],
            currentTime,
            workHours: [],
            shifts: this.shiftsDefault,
        };
    }

    componentDidLoad() {
        this.getSchedules();
    }

    get rightPopupsMap() {
        return {
            "shift": ShiftPopup
        };
    }

    get dialogsMap() {
        return {
            "workHours": WorkHoursDialog,
            "shiftsDel": ShiftsDelDialog,
            "cabinet": CabinetDialog
        };
    }

    onClinicChanged() {
        const shifts = this.shiftsDefault;
        this.setState({ shifts }, this.getSchedules.bind(this));
    }

    refreshVisits() {
        const shifts = this.shiftsDefault;
        this.setState({ shifts }, this.getSchedules.bind(this));
    }

    async getSchedules() {
        const { clinicId, date, dateMode } = this.state;
        const shifts = {
            0: [],
            1: [],
            2: [],
            3: [],
            4: [],
            5: [],
            6: [],
        };

        let startDate = new Date();
        let endDate = new Date();
        if (dateMode === "day") {
            startDate = date.setHours(0, 0, 0, 0);
            endDate = date.setHours(23, 59, 0, 0);
        } else if (dateMode === "week") {
            const { startOfWeek, endOfWeek } = this._helper.date.getWeek(date);
            startDate = startOfWeek;
            endDate = endOfWeek;
        }

        this._helper.showLoading();

        const respCabinets = await this._request.cabinets.getCabinets(clinicId);
        const cabinets = respCabinets?.data || [];
        this.state.activeCabinets = cabinets;

        const respMain = await this._request.doctorsSchedule.getScheduleMain(clinicId, startDate, endDate);
        const mapShift = (respMain?.data || []).reduce((acc, it) => {
            acc[it.id] = it.beginDate;
            return acc;
        }, {});

        const busyCab = [];
        const resp = await this._request.doctorsSchedule.getSchedule(clinicId, startDate, endDate);
        const schedules = (resp?.data || []).reduce((acc, it) => {
            if (!acc[it.cabinetId])
                acc[it.cabinetId] = [];
            it.beginDate = this._helper.date.toLocal(it.beginDate);
            it.endDate = this._helper.date.toLocal(it.endDate);
            it.regular = mapShift[it?.parent?.id] ? mapShift[it?.parent?.id] : false;
            acc[it.cabinetId].push(it);

            if (!busyCab.includes(it.cabinetId))
                busyCab.push(it.cabinetId);

            return acc;
        }, {});

        const respShifts = await this._request.shifts.getShifts(clinicId);
        const sh = respShifts?.data || [];
        if (sh.length > 0 && sh[0].shiftItemList.length > 0) {
            sh[0].shiftItemList.forEach(it => {
                const { dayOfWeek, timeFrom, timeTo, id } = it;
                const index = this._config.dayOfWeek.findIndex(day => day === dayOfWeek);
                shifts[index].push({
                    start: this._helper.date.toLocalTime(timeFrom),
                    end: this._helper.date.toLocalTime(timeTo),
                    id: id,
                    data: schedules[id] ? schedules[id] : null,
                    settingId: sh[0].id
                });
            });
        }

        this.state.shifts = shifts;
        this.state.schedules = schedules;

        const dateSchedules = [];

        const selectedCabinets = [...busyCab];

        const filteredCabinets = cabinets.filter(it => {
            if (selectedCabinets.length < 19 && it.domainId === clinicId && it.status === "ACTIVE" && !selectedCabinets.includes(it.id)) {
                selectedCabinets.push(it.id);
            }
            return true;
        }).map(it => {
            return { id: it.id, name: it.title };
        });

        this.setState({
            dateSchedules,
            filteredCabinets,
            selectedCabinets,
        });

        this._helper.hideLoading();
    }

    changeMode(mode) {
        this.changeState("dateMode", mode);
        this.refreshVisits();
    }

    async changeShifts() {
        const { clinicId } = this.state;
        const dayOfWeek = this._config.dayOfWeek;

        const shiftItemList = [];
        dayOfWeek.forEach(day => {
            shiftItemList.push({
                dayOfWeek: day,
                timeFrom: "08:00:00",
                timeTo: "15:00:00"
            });
            shiftItemList.push({
                dayOfWeek: day,
                timeFrom: "15:00:00",
                timeTo: "22:00:00"
            });
        });

        const info = {
            domainId: clinicId,
            dateFrom: "2024-01-01",
            dateTo: "2024-12-31",
            shiftItemList: shiftItemList
        };

        await this._request.shifts.update(16, info);

    }

    onCurrentDoctorChanged(id) {
        let { currentDoctor } = this.state;
        currentDoctor = currentDoctor === id ? null : id;
        this.setState({ currentDoctor, search: "", });
    }

    onCalendarChanged(date) {
        if (date.getTime() === this.state.date.getTime())
            return;

        this.setState({
            date,
            schedules: [],
        }, this.getSchedules.bind(this));
    }

    setToCalendarCurrentDate(date) {
        this.calendar.onChange(this._helper.date.clearTime(date));
    }

    onChangeWorkHours(shifts) {
        this.changeState("shifts", shifts);
    }

    onCancelEdit() {
        const isEditCabinet = false;
        const isEdit = false;
        this.setState({ isEditCabinet, isEdit });
    }

    onDownloadXls() {
        const { date, dateMode } = this.state;
        const { slotsOnDay } = this.scheduleView;
        if (dateMode === "week")
            this._xlsx.reportSchedule(date, slotsOnDay);
    }

    onChangeMode(i) {
        this.changeMode(i ? "week" : "day");
    }

    renderDoctors() {
        const { search, currentDoctor } = this.state;

        return (
            <Doctors
                search={search.toLowerCase()}
                activeId={currentDoctor}
                onClick={this.onCurrentDoctorChanged.bind(this)}
            />
        );
    }

    renderCalendarZone() {
        const { search, dateMode } = this.state;

        return (
            <div className="flex col gap24">
                <Calendar
                    ref={el => this.calendar = el}
                    dateMode={dateMode}
                    onChange={this.onCalendarChanged.bind(this)}
                />
                <div className="doctorLabel label text blockTitle">{this.tr("main", "list")}</div>
                <Search
                    value={search}
                    placeHolder={"main.searchDoctor"}
                    onChange={this.changeState.bind(this, "search")}
                />
                {this.renderDoctors()}
            </div>
        );
    }

    renderActionsZone() {
        const { date, dateMode } = this.state;

        return (
            <div className="flex centerV gap16">
                <div className="flex1">
                    <ControlDate
                        period={dateMode}
                        value={date}
                        onChange={this.setToCalendarCurrentDate.bind(this)}
                    />
                </div>
                <div className="flex gap16" style={{ paddingRight: "24px" }}>
                    {/*<div className="wrapControlDate flex gap8 rad8 text p1SemiBold">
                        <div
                            className={`contolDateItem rad8 ${dateMode === "day" ? "active" : ""}`}
                            onClick={this.changeMode.bind(this, "day")}>
                            {this._helper.string.capitalize(this.tr("main.oneD"))}
                        </div>
                        <div
                            className={`contolDateItem rad8 ${dateMode === "week" ? "active" : ""}`}
                            onClick={this.changeMode.bind(this, "week")}>
                            {this.tr("schedule.week")}
                        </div>
                    </div>*/}
                    <ControlData
                        defaultMode={dateMode === "day" ? 0 : 1}
                        items={["main.oneD", "schedule.week"]}
                        onClick={this.onChangeMode.bind(this)} />
                    <ButtonIconSelect
                        name="setting"
                        translate={true}
                        items={[]}
                    />
                </div>
            </div>
        );
    }

    renderSchedule() {
        const { isEdit } = this.state;
        return (<div className="wrapSchedule flex flex1 minH0 hidden">
            <div className="calendarZone padding scrolling">
                {this.renderCalendarZone()}
            </div>

            <div className="flex1 flex col">
                {this.renderActionsZone()}
                <div className="mainZone flex1 flex minH0 hidden">
                    <ScheduleView
                        ref={(el) => this.scheduleView = el}
                        info={this.state}
                        openShift={isEdit ? this.openRightPopup.bind(this, "shift") : null}
                        refreshVisits={this.refreshVisits.bind(this)}
                    />
                </div>
            </div>

        </div>);
    }

    renderNotSchedule() {
        return (<div className="flex flex1 col centerAll">
            <div className="flex col gap16 centerV">
                <div className="flex text blockTitle first">{this.tr("schedule.notCreated")}</div>
                <div className="text p1 second">{this.tr("schedule.firstSchedule")}</div>
                <div className="wrapButton">
                    <Button
                        type={"primary"}
                        size={"small"}
                        label={"schedule.newSchedule"}
                        icon={<PlusIcon />}
                        onClick={this.toggleState.bind(this, "isSchedule")}
                    />
                </div>
            </div>
        </div>);
    }

    renderPage() {
        const { isSchedule, isEdit, shifts, clinicId, date, dateMode } = this.state;

        const currDate = new Date();

        return (
            <div className="flex1 flex col">
                <div className="header flex between centerV padding">
                    {!isEdit && <div className="left flex text pageTitle">
                        {this.tr("schedule.doctorsSchedule")}
                    </div>}
                    {isEdit && <div className="flex gap16">
                        <ButtonIcon name="arrowLeft" onClick={this.changeState.bind(this, "isEdit", false)} />
                        <div className="flex col">
                            <div className="left text blockTitle">
                                {this.tr("schedule.doctorsSchedule")}
                            </div>
                            <div className="red text p2">
                                {this.tr("schedule.editMode")}
                            </div>
                        </div>
                    </div>}
                    {isSchedule && !isEdit && <div className="flex gap16">
                        <Button
                            type={"secondary"}
                            size={"small"}
                            label={"schedule.downloadSchedule"}
                            active={false}
                            onClick={this.onDownloadXls.bind(this)}
                        />
                        {(dateMode !== "day" || (!(date < currDate) && dateMode === "day")) && <ButtonIconSelect
                            name="edit"
                            onClick={this.changeState.bind(this, "isEdit", true)}
                        />}
                    </div>}
                    {isSchedule && isEdit && <div className="flex gap16">
                        <ButtonIconSelect
                            translate={true}
                            items={[
                                { name: "schedule.changeOpeningHours", onClick: this.openDialog.bind(this, "workHours", { shifts, clinicId }, this.onChangeWorkHours.bind(this)) },
                                { name: "schedule.changeCabinets", onClick: this.changeState.bind(this, "isEditCabinet", true) },
                                { name: "schedule.addCabinet", onClick: this.openDialog.bind(this, "cabinet", { create: true, domainId: clinicId }, this.refreshVisits.bind(this)) },
                                { name: "schedule.groupDeletionShifts", onClick: this.openDialog.bind(this, "shiftsDel", {}, null) }
                            ]}
                        />
                        <Button
                            type="secondary"
                            size={"small"}
                            label={"main.cancel"}
                            onClick={this.onCancelEdit.bind(this)}
                        />
                        <Button
                            size={"small"}
                            label={"schedule.saveChanges"}
                            onClick={this.changeState.bind(this, "isEdit", false)}
                        />
                    </div>}
                </div>
                {isSchedule ? this.renderSchedule() : this.renderNotSchedule()}
            </div>
        );
    }
}


